import { Tooltip } from 'antd';
import { CSSProperties, ReactNode } from 'react';

interface CustomTooltipProps {
  isArrow?: boolean;
  classname?: string;
  widthInner?: string;
  innerStyle?: CSSProperties;
  title: string;
  children?: ReactNode;
}

export const CustomTooltip = ({
  title,
  isArrow,
  children,
  classname,
  innerStyle,
  widthInner,
}: CustomTooltipProps) => {
  return (
    <Tooltip
      title={title}
      arrow={isArrow ?? false}
      className={classname}
      overlayInnerStyle={{
        fontSize: '12px',
        lineHeight: '16px',
        borderRadius: 'var(--radius)',
        backgroundColor: 'var(--color-text)',
        width: `${widthInner ?? ''}px`,
        ...innerStyle,
      }}
    >
      {children}
    </Tooltip>
  );
};
